import store, { storeReducers } from '../store';
import { useDispatch } from 'react-redux';
import { Action } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { FontFamilyType, FontSizesType } from '@nicheinc/campus-ds';
import {
	CaptionTextCaseEnum,
	CaptionTypeEnum,
} from '@app/constants/modules/video';

export type fetchAction = {
	type: string[];
	callAPI?: () => Promise<AxiosResponse<any>>;
	shouldCallAPI?: () => true;
	callFetch?: () => Promise<any>;
	payload?: { [key: string]: any };
} & Action;

export type ResponseAction = Action & {
	response?: GenericAPIResponse | any;
	error?: GenericAPIResponse | any;
	payload?: GenericAPIResponse | any;
	[key: string]: any;
};

export type clientAction = Action & {
	client?: any;
};

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();

export type RootState = ReturnType<typeof storeReducers>;

type PagesObject = {
	[key: string]: string[];
};

export type EntityPaginationObject = {
	pages: PagesObject;
	currentPage: number | null;
	totalPages?: number | null;
	count?: number | null;
	totalTabCount?: number | null;
};

export type GenericEntityState = {
	loading: boolean;
	// should have a generic response type for example {status,message}
	response: GenericAPIResponse | null;
	// should have a n error type defined in the axios setup (interceptors) for http errors
	error: any;
	pagination?: EntityPaginationObject;
	custom?: {
		[key: string]: any;
	};
	[key: string]: any;
};

export type GenericAPIResponse = {
	status: number | null;
	message: string | null;
	[key: string]: any;
};

export type CaptionType = {
	_id?: string;
	type?: CaptionTypeEnum;
	textCase?: CaptionTextCaseEnum;
	font?: FontFamilyType;
	fontSize?: FontSizesType;
	highlightColor?: string;
	verticalPositioning?: string;
	rotation?: string;
};
export type VideoPageSettingField = 'autoplay' | 'captionWarning' | 'replies';

export type VideoPageSettingsType = {
	autoplay?: boolean;
	captionWarning?: boolean;
	captionEnabled?: boolean;
	replies?: boolean;
	automaticRedirect?: boolean;
	automaticRedirectThumbnail?: string;
	hideRecordersName?: boolean;
	caption?: CaptionType;
};
